<template>

    <label class="switch">
        <input type="checkbox" v-model="modelValue">
        <span class="slider"></span>
    </label>

</template>

<style lang="scss" scoped>

    $switch-width: 42px;
    $switch-height: 22px;
    $switch-knob-size: 18px;
    $switch-padding: 2px;
    $switch-translate: $switch-width - $switch-knob-size - (2 * $switch-padding);

    .switch {
        display: inline-block;
        height: $switch-height;
        position: relative;
        width: $switch-width;
        input {
            height: 0;
            opacity: 0;
            width: 0;
        }
        .slider {
            background-color: $color-rule;
            border-radius: $switch-height;
            bottom: 0;
            cursor: pointer;
            left: 0;
            position: absolute;
            right: 0;
            top: 0;
            transition: 0.3s;
            &:before {
                background-color: $color-white;
                border-radius: 50%;
                bottom: $switch-padding;
                content: "";
                height: $switch-knob-size;
                left: $switch-padding;
                position: absolute;
                transition: 0.3s;
                width: $switch-knob-size;
            }
        }
        input:checked + .slider {
            background-color: $color-primary;
            &:before {
                transform: translateX($switch-translate);
            }
        }
    }

</style>

<script>

export default {

    props: {
        model: {
            type: Boolean,
            required: true,
        },
    },

    computed: {

        modelValue: {
            get() {
                return this.model;
            },
            set(val) {
                this.$emit('input', val);
            }
        },

    }
}

</script>